<template>
  <main class="tf-container compra-retorno">
    <h1>{{ pago ? 'Pagamento confirmado' : 'Pagamento da compra' }}</h1>
    <p v-if="erro" role="alert">{{ erro }}</p>
    <p v-if="carregando" role="status">Atualizando situação…</p>
    <template v-if="compra">
      <p>{{ pago ? 'Obrigado! Seu pagamento foi confirmado.' : 'Consulte a situação e continue o pagamento no checkout.' }}</p>
      <p v-if="publico">Situação: {{ estado }}</p>
      <button v-if="compra.cobranca" class="tf-btn accent large" @click="abrir">{{ pago ? 'Acessar comprovante' : 'Pagar' }}</button>
      <button v-if="compra.cobranca" class="tf-btn large" :disabled="carregando" @click="atualizar">Atualizar situação</button>
    </template>
    <p v-else>Para continuar esta compra, confirme seus dados na página do produto.</p>
    <router-link :to="{ name: 'produto', params: { hash: $route.params.hash } }">Voltar ao produto</router-link>
  </main>
</template>
<script>
import { recuperarCompra, consultarCompra, acessarCheckout } from '@/services/checkout.service';
export default {
  name: 'ProdutoCheckoutView',
  data: () => ({ compra: null, publico: null, erro: '', carregando: false, ativo: true, timer: null }),
  computed: {
    pago() { return this.publico ? this.publico.estado === 'paid' : this.compra?.ja_pago; },
    estado() { return ({ paid: 'Pago', ready: 'Aguardando pagamento', pending: 'Aguardando confirmação', failed: 'Pagamento não aprovado', expired: 'Link expirado', canceled: 'Cancelado', unknown: 'Pagamento em conferência', processing: 'Processando', refunded: 'Estornado', partial_refund: 'Estorno parcial', disputed: 'Em contestação' })[this.publico?.estado] || 'Em conferência'; }
  },
  mounted() {
    this.compra = recuperarCompra(this.$route.params.hash); this.atualizar();
    window.addEventListener('pageshow', this.retomar); document.addEventListener('visibilitychange', this.retomar);
  },
  beforeUnmount() { this.ativo = false; clearTimeout(this.timer); window.removeEventListener('pageshow', this.retomar); document.removeEventListener('visibilitychange', this.retomar); },
  methods: {
    retomar() { if (!document.hidden) this.atualizar(); },
    abrir() { try { acessarCheckout(this.compra.cobranca); } catch (e) { this.erro = e.message; } },
    async atualizar() {
      if (!this.compra?.cobranca || this.carregando || !this.ativo) return;
      clearTimeout(this.timer); this.carregando = true; this.erro = '';
      try { this.publico = await consultarCompra(this.compra.cobranca); }
      catch (e) { this.erro = e.message; }
      finally { this.carregando = false; if (this.ativo && !this.pago && !document.hidden) this.timer = setTimeout(() => this.atualizar(), 15000); }
    }
  }
};
</script>
<style scoped>.compra-retorno{padding:40px 20px;max-width:640px}.compra-retorno p,.compra-retorno button{margin:20px 0}.compra-retorno h1{font-size:26px}.compra-retorno button:not(.accent){color:#264653;background:white}.compra-retorno a{color:#264653;text-decoration:underline}</style>
